import React from 'react';
import { CompassIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { images } from '../../data/content';
const flow = ['Case', 'Problem', 'Objective', 'Movement', 'Control', 'Checkpoint', 'Next decision'];
export function Hero() {
  return <header className="bg-cream px-5 pb-14 pt-8 sm:pt-12" data-id="element-149" data-mp="hvz3lxs4hefg">
      <div className="mx-auto max-w-5xl text-center" data-id="element-150" data-mp="mu0lifdtb7pc">
        <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-151" data-mp="mtiubx60bjoa">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-700 text-white" data-id="element-152" data-mp="quuehn643cp3">
            <CompassIcon className="h-5 w-5" aria-hidden="true" data-id="element-153" data-mp="vndrahwz63su" />
          </span>
          <span className="font-serif text-xl font-bold text-brand-800" data-id="element-154" data-mp="10loyekvvy07d">Ortho Decision System™</span>
        </div>

        <h1 className="mt-7 font-serif text-[34px] leading-[1.08] sm:text-5xl lg:text-6xl font-extrabold text-ink" data-id="element-155" data-mp="15ll2ek4l1rmx">
          Work through an orthodontic case in{' '}
          <em className="text-brand-600" data-id="element-156" data-mp="9njaqcmk8gcq">15 minutes</em>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] sm:text-xl leading-relaxed text-muted" data-id="element-157" data-mp="9lq0yognhg0i">
          A <strong className="text-ink" data-id="element-158" data-mp="4qsu9o6ufiqs">7-step clinical decision framework</strong> for knowing what to do first,
          what to protect, and which decision comes next — when you’re looking at a real patient.
        </p>

        <ol className="mx-auto mt-6 flex max-w-2xl flex-wrap items-center justify-center gap-x-1.5 gap-y-2 text-[13px] sm:text-sm font-semibold" data-id="element-159" data-mp="seamfku0siua">
          {flow.map((step, i) => <li key={step} className="flex items-center gap-1.5" data-id="element-160" data-mp="nhk04frmgr0f" data-mpi={i}>
              <span className="rounded-full bg-brand-100 px-3 py-1 text-brand-800" data-id="element-161" data-mp="imxwwzvp24rf">{step}</span>
              {i < flow.length - 1 && <span className="text-brand-300" aria-hidden="true" data-id="element-162" data-mp="ekt7kdca3ual">→</span>}
            </li>)}
        </ol>

        <img src={images.hero} alt="The six volumes of the Ortho Decision System with tablet and phone decision maps" className="mx-auto mt-8 w-full max-w-3xl rounded-2xl mix-blend-multiply" data-id="element-163" data-mp="16e3crf1mwx1q" />

        <p className="mx-auto mt-4 max-w-xl text-[15px] sm:text-base text-muted" data-id="element-164" data-mp="35la02tm2ffyr">
          <strong className="text-ink" data-id="element-165" data-mp="2qwdsexnx84yo">6 premium volumes</strong>, <strong className="text-ink" data-id="element-166" data-mp="2qvudlptkhwov">5 professional bonuses</strong>,
          decision maps, case-analysis worksheets and checklists.
        </p>

        <div className="mt-7" data-id="element-167" data-mp="2huwglrhjqpfs">
          <CtaButton id="first-cta" label="Get the Ortho Decision System™" data-id="element-168" data-mp="2humsk9g2ascq" />
        </div>
        <p className="mt-4 text-sm text-muted" data-id="element-169" data-mp="2mvkackx5tkdp">
          Instant digital access · One-time payment of <strong className="text-ink" data-id="element-170" data-mp="27ybdjbp37oel">USD $27</strong> · Lifetime access · 7-Day
          Guarantee
        </p>

        <Countdown data-id="element-171" data-mp="2cx4g492u5uzz" />
      </div>
    </header>;
}